import { render } from "./Notifications.vue?vue&type=template&id=5eb82b1a&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"

import "./Notifications.vue?vue&type=style&index=0&id=5eb82b1a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5eb82b1a"

export default script